module.exports = __webpack_public_path__ + "img/[闪电].9eb94483.svg";